/**
 * Created by slava on 4/12/17.
 */

const Synchronizer = function () {
    ConnectorEventEmitter.call(this);

    this.setStatus(SYNC_STATUS.INIT);

    this.adapters = {};
};

Synchronizer.prototype = Object.create(ConnectorEventEmitter.prototype);
Synchronizer.prototype.constructor = Synchronizer;

Synchronizer.prototype.initialize = function () {
    this.session = this.load() || "a";

    this.detectTransport();
    this.transport.initialize();
};

Synchronizer.prototype.detectTransport = function () {
    const TransportClass = SyncTransportClient.isAppropriate() ? SyncTransportClient : SyncTransportRest;

    if (this.transport instanceof TransportClass) {
        return;
    }

    if (this.transport) {
        this.transport.reset();
    }

    this.transport = new TransportClass(this);
};

Synchronizer.prototype.usesRestTransport = function () {
    return this.transport instanceof SyncTransportRest;
};

Synchronizer.prototype.connect = function () {
    this.transport.connect();
};

Synchronizer.prototype.start = function (options = {}) {
    if (!this.transport.isConnected()) {
        this.transport.whenConnected(() => this.start(options));
        return;
    }

    if (this.started) {
        return;
    }

    this.options = options;

    if (options.adapters) {
        Object.assign(this.adapters, options.adapters);
    }

    this.progressComparator = options.progressComparator;

    connector.timeouts.setInterval(() => this.send(), this.transport.config.sendInterval);
    connector.timeouts.setInterval(() => this.checkSession(), connector.utils.parseInterval("1 minute"));

    this.started = true;

    this.checkSession();

    connector.social.on("login", () => this.checkSession());
};

Synchronizer.prototype.load = function () {
    const data = connector.dataLoader.load(SimpleDataLoader.TYPES.SYNC_SESSION) || {};
    const session = data.session;

    if (session !== null && session !== undefined) {
        return session;
    }

    return connector.dataLoader.localStorage.getItem(`${SimpleDataLoader.GetOldLocalStoragePrefix()}_session`);
};

Synchronizer.prototype.save = function () {
    connector.dataLoader.save(SimpleDataLoader.TYPES.SYNC_SESSION, { session: this.session });
};

Synchronizer.prototype.disable = function () {
    if (SYNC_STATUS.DISABLE === this.status) {
        return;
    }

    this.reset();
    this.setStatus(SYNC_STATUS.DISABLE);
};

Synchronizer.prototype.reset = function () {
    if (SYNC_STATUS.DISABLE !== this.status) {
        this.setStatus(SYNC_STATUS.INIT);
    }

    this.session = "a";

    this.save();

    this.transport.reset();
};

Synchronizer.prototype.addAdapter = function (code, adapter) {
    this.adapters[code] = adapter;
};

Synchronizer.prototype.addSendTask = function (...types) {
    this.transport.addSendTask(...types);
};

Synchronizer.prototype.send = function () {
    if (SYNC_STATUS.IDLE !== this.status) {
        return;
    }

    this.transport.send((code) => {
        if (code === connector.CODE_FAILED) {
            this.trigger("send:error");
            return;
        }

        if (code === "sessionExpired") {
            this.reset();
            this.checkSession();
            return;
        }

        this.trigger("send:success");
    });
};

Synchronizer.prototype.syncOut = function () {
    this.transport.setSyncOut();
    this.send();
};

Synchronizer.prototype.checkSession = function () {
    if (![SYNC_STATUS.ERROR, SYNC_STATUS.INIT].includes(this.status) || !this.started) {
        return;
    }

    const header = this.options.getHeader();

    this.transport.checkSession(header, (code, response) => {
        if (["alreadyRunning"].includes(code)) {
            return;
        }

        if (code !== connector.CODE_SUCCEED) {
            this.setStatus(code && code.status === 403 ? SYNC_STATUS.NEED_LOGIN : SYNC_STATUS.ERROR);
            this.trigger("checkSession:error");
            return;
        }

        const newSession = response.session;

        if (!newSession) {
            this.setStatus(SYNC_STATUS.IDLE);
            return;
        }

        this.conflictData = {
            newSession,
            localSnapshot: this.getLocalSnapshot(),
            remoteSnapshot: response.snapshot
        };

        this.setStatus(SYNC_STATUS.CONFLICT);
        this.trigger("checkSession:conflict");
    });
};

Synchronizer.prototype.resolveConflict = function (localSnapshot, remoteSnapshot) {
    this.setStatus(remoteSnapshot ? SYNC_STATUS.PULL : SYNC_STATUS.PUSH);
};

Synchronizer.prototype.getLocalSnapshot = function () {
    const snapshot = {};

    for (const type of Object.keys(this.adapters)) {
        if (this.adapters[type].getInfo) {
            snapshot[type] = this.adapters[type].getInfo();
        }
    }

    return snapshot;
};

Synchronizer.prototype.push = function (newSession) {
    this.session = newSession;
    this.save();

    this.setStatus(SYNC_STATUS.IDLE);

    this.syncOut();
};

Synchronizer.prototype.pull = function (newSession, snapshot) {
    console.log("apply snapshot", snapshot, newSession);

    this.setStatus(SYNC_STATUS.PULL);

    this.transport.reset();
    this.session = newSession;
    this.save();

    const syncTypes = Object.keys(this.adapters)
        .sort((a, b) => (this.adapters[a].order || 0) - (this.adapters[b].order || 0));

    for (const type of syncTypes) {
        if (this.adapters[type].beforeUpdate) {
            this.adapters[type].beforeUpdate(snapshot);
        }
    }

    for (const type of syncTypes) {
        if (type in snapshot && this.adapters[type].updateInfo) {
            this.adapters[type].updateInfo(snapshot[type]);
        }
    }

    for (const type of syncTypes) {
        if (this.adapters[type].afterUpdate) {
            this.adapters[type].afterUpdate();
        }
    }

    this.setStatus(SYNC_STATUS.IDLE);
};

Synchronizer.prototype.setStatus = function (status) {
    if (this.status === status) {
        return;
    }

    this.status = status;
    this.trigger("changeStatus", status);
};

const SYNC_STATUS = {
    INIT: "init",
    IDLE: "idle",
    CONFLICT: "conflict",
    PULL: "pull",
    PUSH: "push",
    DISABLE: "disable",
    WAIT: "wait",
    NEED_LOGIN: "needLogin",
    ERROR: "error"
};

connector.SYNC_STATUS = SYNC_STATUS;

connector.synchronizer = new Synchronizer();
